// extracted by css-extract-rspack-plugin
export default {"responseCard":"Sid9QnyPVmoLn8VA","responseContent":"mznBtU9iptIzTwh0","responseIcon":"MHtdisIoNPAanlGC"};